import { render, staticRenderFns } from "./ReservationMediaDelete.vue?vue&type=template&id=3ab2348c&scoped=true&"
import script from "./ReservationMediaDelete.vue?vue&type=script&lang=js&"
export * from "./ReservationMediaDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab2348c",
  null
  
)

export default component.exports